export default function (opts) {
  var options = {
    elements: [],
    offset: () => 0,
    onEnter: element => {}
  }

  var state = {
    scrollTop: 0,
    current: null
  }

  var setOptions = opts => { options = Object.assign({}, options, opts) }
  var setState = newState => { state = Object.assign({}, state, newState) }

  setOptions(opts)

  function check (e) {
    var scrollTop = window.scrollY + options.offset()
    setState({
      scrollTop: scrollTop
    })
    tops(options.elements)
  }

  function tops (elements) {
    var newElements = elements.slice()
    newElements.reverse()
    newElements.some(e => {
      if (state.scrollTop >= e.element.offsetTop) {
        if (state.current !== e.index) {
          setState({ current: e.index })
          options.onEnter(e.element)
        }
        return true
      }
    })
  }

  return {
    check
  }
}